var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-input"},_vm._l((_vm.value),function(item){return _c('button',{attrs:{"type":"button"}},[_c('div',{staticClass:"badge"},[_vm._v(" "+_vm._s(item[_vm.labels])+" ")]),_c('i',{staticClass:"icon ion-md-close",on:{"click":function($event){return _vm.remove(item)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }